import { gql } from '@apollo/client';

/**
 * The registration form's "already enrolled?" path: find by ID number, warn about a likely
 * duplicate, and load everything on file so the form saves as an edit.
 */

const PERSON_MATCH_FIELDS = `
  personId
  name
  identifier
  dob
  canEdit
  canEditHealthInformation
`;

export interface PersonMatch {
    personId: number;
    name: string | null;
    identifier: string | null;
    dob: string | null;
    canEdit: boolean;
    canEditHealthInformation: boolean;
}

export const PERSON_BY_IDENTIFIER = gql`
query PersonByIdentifier($identifier: String!) {
  personByIdentifier(identifier: $identifier) { ${PERSON_MATCH_FIELDS} }
}`;

export const POSSIBLE_EXISTING_PEOPLE = gql`
query PossibleExistingPeople($name: String!, $dob: String!) {
  possibleExistingPeople(name: $name, dob: $dob) { ${PERSON_MATCH_FIELDS} }
}`;

/** Everything the form shows, as stored. `registration` is null when there is no row yet. */
export const PERSON_FOR_EDIT = gql`
query PersonForRegistrationEdit($personId: Int!) {
  user(personId: $personId) {
    id
    name
    preferredName
    scriptName
    phone
    address
    dob
    gender
    identifier
    picturePermission
    tags { id name }
    supportingDocuments { id }
    registration {
      id
      consentDataCollection
      healthSafetyBriefed
      consentHealthSafety
      idSightedByCM
      guardianName
      guardianDob
      guardianRelationship
      guardianIsMinorNoAlternative
      guardianConsentsToChildData
      guardianIdSightedConfirmsRelationship
      guardianNoIdButConfirmed
      guardianPhone
      emergencyContactName
      emergencyContactPhone
      emergencyContactRelationship
      healthInformation
    }
  }
}`;
